import CryptoJS from 'crypto-js';
const getShortForm = (fullName) => {
    if (!fullName) return "";
    const words = fullName.split(" ");
    var spLength = words.length;
    var str = '';
    if(spLength >= 2){
        str = words[0].charAt(0).concat(words[spLength-1].charAt(0));
    }
    else if(spLength == 2){
        str = words[0].charAt(0).concat(words[1].charAt(0));
    }
    else{
        str = words[0].charAt(0).concat(words[0].charAt(1));
    }
    return str.toUpperCase();
}

const ValidateEmail = (email) => {
    if (!email) return "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const specialCharacterValidate = (inputVal) => {
    return inputVal.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/ /g, '_');
}

const getLocalStrogeValue = (param) => {
    const localStorageValue = localStorage.getItem(param);
    return localStorageValue
}

const base64Encode = (input) => {
    return btoa(input);
}
const base64Decode = (input) => {
    return atob(input);
}

const formatDate = (dateString) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: timeZone
    }).format(date);
}

const safeDecrypt = (param) => {
    const { encryptedData, base64Key, base64Iv } = param;
    try {
        const key = CryptoJS.enc.Utf8.parse(base64Key);
        const iv = CryptoJS.enc.Utf8.parse(base64Iv);

        const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        const plaintext = decrypted.toString(CryptoJS.enc.Utf8);

        
        if (!plaintext || plaintext.trim() === "") {
            throw new Error("Decryption failed: invalid key or corrupted data");
        }

        return plaintext;
    } catch (err) {
        console.error("Error while decrypting:", err.message);
        return null;
    }
}

export {
    getShortForm, 
    ValidateEmail, 
    getLocalStrogeValue,
    base64Encode,
    base64Decode,
    specialCharacterValidate,
    formatDate,
    safeDecrypt
}